import { Loader2, ArrowDown } from 'lucide-react';
import { cn } from '@/lib/utils';

// ============================================================================
// PullIndicator — Visual feedback for pull-to-refresh gesture
// Shows an arrow (pulling) or spinner (refreshing) at the top of content
// ============================================================================

interface PullIndicatorProps {
  pullDistance: number;
  isRefreshing: boolean;
  threshold?: number;
}

export function PullIndicator({
  pullDistance,
  isRefreshing,
  threshold = 80,
}: PullIndicatorProps) {
  if (pullDistance === 0 && !isRefreshing) return null;

  const progress = Math.min(pullDistance / threshold, 1);
  const ready = progress >= 1;

  return (
    <div
      className="flex items-center justify-center overflow-hidden transition-[height] duration-(--duration-base) ease-out"
      style={{ height: isRefreshing ? 40 : pullDistance }}
    >
      {isRefreshing ? (
        <Loader2 className="h-5 w-5 animate-spin text-primary" />
      ) : (
        <ArrowDown
          className={cn(
            'h-5 w-5 transition-all duration-(--duration-fast)',
            ready ? 'text-primary rotate-180' : 'text-muted-foreground',
          )}
          style={{ opacity: progress, transform: `rotate(${ready ? 180 : 0}deg)` }}
        />
      )}
    </div>
  );
}
